import { useCallback, useEffect, useRef, useState } from 'react';
import type { ReactNode } from 'react';
import { ToastContext } from '../lib/toast';

/* Тост из макета: одна плашка на всю страницу, новый вызов перебивает предыдущий,
   живёт 2 секунды. Текст после скрытия НЕ стирается — плашка просто уезжает,
   ровно как в макете (там менялся textContent, а класс `on` снимался). */

export function ToastHost({ children }: { children: ReactNode }) {
    const [text, setText] = useState('');
    const [on, setOn] = useState(false);
    const timer = useRef<number | undefined>(undefined);

    const toast = useCallback((message: string) => {
        setText(message);
        setOn(true);
        window.clearTimeout(timer.current);
        timer.current = window.setTimeout(() => setOn(false), 2000);
    }, []);

    useEffect(() => () => window.clearTimeout(timer.current), []);

    return (
        <ToastContext.Provider value={toast}>
            {children}
            <div className={on ? 'toast on' : 'toast'} role="status" aria-live="polite">
                {text}
            </div>
        </ToastContext.Provider>
    );
}
